import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { SERVICES } from "@/data/services";

const Card = ({ s, i }) => {
  const Icon = s.icon;
  return (
    <Reveal delay={(i % 3) * 0.08} className={`${s.span} group`}>
      <Link
        to={`/services/${s.slug}`}
        data-testid={`service-card-${s.slug}`}
        aria-label={`${s.title} — view details`}
        className={`relative block h-full overflow-hidden bg-quantum-bg2 border border-white/10 hover:border-quantum-gold/50 transition-colors duration-500 ${
          s.tall ? "min-h-[420px]" : "min-h-[260px]"
        }`}
      >
        {s.cardImage && (
          <div className="absolute inset-0">
            <img
              src={s.image}
              alt={s.title}
              className="h-full w-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-700 ease-out"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-quantum-bg2 via-quantum-bg2/50 to-transparent" />
          </div>
        )}
        <div className="relative z-10 flex h-full flex-col justify-between p-8 md:p-10">
          <div className="flex items-start justify-between">
            <span className="grid place-items-center h-12 w-12 rounded-full border border-white/15 text-quantum-gold group-hover:border-quantum-gold group-hover:bg-quantum-gold/10 transition-colors duration-500">
              <Icon size={20} strokeWidth={1.5} />
            </span>
            <ArrowUpRight
              className="text-quantum-muted group-hover:text-quantum-gold group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500"
              size={24}
            />
          </div>
          <div>
            <span className="font-serif-q text-quantum-gold text-lg block mb-1">{s.num}</span>
            <h3 className="font-serif-q text-3xl md:text-4xl text-quantum-text mb-3 font-light">
              {s.title}
            </h3>
            <p className="text-quantum-muted text-base leading-relaxed max-w-md">{s.short}</p>
          </div>
        </div>
      </Link>
    </Reveal>
  );
};

export const Services = () => (
  <section id="services" className="px-6 md:px-12 lg:px-24 py-24 md:py-32 lg:py-40" data-testid="services-section">
    <Reveal className="max-w-3xl mb-16 md:mb-24">
      <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-quantum-gold mb-6">What we do</p>
      <h2 className="font-serif-q text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight font-light text-quantum-text">
        One partner for every ambition, worldwide.
      </h2>
      <p className="text-quantum-muted mt-6 text-lg">Explore each service — click any card to learn more.</p>
    </Reveal>

    <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6 auto-rows-fr">
      {SERVICES.map((s, i) => (
        <Card key={s.slug} s={s} i={i} />
      ))}
    </div>
  </section>
);
